/* eslint-disable */
import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store/store';
import vuexI18n from 'vuex-i18n';
import translationsDe from './assets/translations/de';
import translationsFr from './assets/translations/fr';
import VueScrollReveal from 'vue-scroll-reveal';
import VueScrollTo from 'vue-scrollto';

// Scroll to elements
Vue.use(VueScrollTo, {
  container: 'body',
  duration: 1500,
});

// Scroll reveal
// https://github.com/scrollreveal/scrollreveal/wiki/Getting-Started-(v3.x)
Vue.use(VueScrollReveal, {
  duration: 2000,
  easing: 'cubic-bezier(0.2, 0.94, 0.11, 1)',
  scale: 1,
  opacity: 0.1,
  distance: '100px',
  viewFactor: 0.5,
});

// Multilanguage
Vue.use(vuexI18n.plugin, store);
if (window.navigator.language.indexOf('de') >= 0) {
  Vue.i18n.set('de');
} else {
  Vue.i18n.set('fr');
}
Vue.i18n.add('de', translationsDe);
Vue.i18n.add('fr', translationsFr);

Vue.config.productionTip = false;

// https://alligator.io/vuejs/vue-router-modify-head/
router.beforeEach((to, from, next) => {
  const nearestWithTitle = to.matched
    .slice()
    .reverse()
    .find(r => r.meta && r.meta.title);
  const nearestWithMeta = to.matched
    .slice()
    .reverse()
    .find(r => r.meta && r.meta.metaTags);
  if (nearestWithTitle) document.title = nearestWithTitle.meta.title;
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));
  if (!nearestWithMeta) return next();
  nearestWithMeta.meta.metaTags
    .map(tagDef => {
      const tag = document.createElement('meta');
      Object.keys(tagDef).forEach(key => {
        tag.setAttribute(key, tagDef[key]);
      });
      tag.setAttribute('data-vue-router-controlled', '');
      return tag;
    })
    .forEach(tag => document.head.appendChild(tag));
  next();
});

new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js